import React from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';
import Container from '../ui/Container';
import SectionHeader from '../ui/SectionHeader';
import BrandLogoCard from '../ui/BrandLogoCard';
import { BRANDS } from '../../data/brands';

export default function BrandsSection({ id }) {
  return (
    <Box as="section" id={id} py={{ base: 14, md: 20 }} bg="surface.muted">
      <Container>
        <SectionHeader
          title="Marcas con las que trabajamos"
          description="Equipos y materiales de fabricantes reconocidos del sector eléctrico."
        />
        <SimpleGrid columns={{ base: 2, sm: 3, lg: 5 }} spacing={4}>
          {BRANDS.map(brand => (
            <BrandLogoCard key={brand.name} brand={brand} />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
